import { render, staticRenderFns } from "./TipController.vue?vue&type=template&id=240999eb&scoped=true&"
import script from "./TipController.vue?vue&type=script&lang=ts&"
export * from "./TipController.vue?vue&type=script&lang=ts&"
import style0 from "./TipController.vue?vue&type=style&index=0&id=240999eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240999eb",
  null
  
)

export default component.exports